import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NewApprovedPayer } from "../models/approved-payer";
import { Regex } from "@pg-app/shared/constants/regex";
import { SendPaymentInstructionComponent } from "@pg-app/client/send-payment-instruction/containers/send-payment/send-payment-instruction.component";
import { MatDialog } from "@angular/material/dialog";
import { ShareService } from "@nttp/common-service/share-service";
import { Observable } from "rxjs";
import { UtilityService } from "@nttp/common-service/utility-service";
import { BankingTypes } from "@pg-app/shared/constants/banking-types-constants";
import { fasterPayGbpBankDetailsValidator } from "@pg-app/client/manage-recipient/constants/fasterpay-gbp-validator";
import { swiftOrBankCodeValidator } from "@pg-app/client/manage-recipient/constants/swift-bank-validator";
import { swiftCodeValidator } from "@pg-app/client/manage-recipient/constants/swift-code-validator";
import { RecipientService } from "@pg-app/client/manage-recipient/services/recipient.service";
import { debounceTime } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BankAccountTypes } from "@pg-app/client/payment/constants/bank-account-type-list";
import { RegistrationStep2Service } from "@pg-app/client/services/registrationStep2.service";
import { AddRecipientFrom } from "@pg-app/client/manage-recipient/constants/add-recipient-constants";
import { Country } from "@pg-app/shared/models/country";
import { BeneficiaryTypes } from "@pg-app/client/payment/constants/beneficiary-type-list";
import { PaymentServiceProvider } from "../models/payment-service-provider";
import { ApprovedPayerService } from "../services/approved-payer-service";
import { VerifyTypeSendCodeEnum } from "@nttp/enum/verify-type.enum";
import { VerifyCodeErrorEnum } from "@nttp/enum/verify-code-error-type.enum";
import { AuthyTicketTypeEnum } from "@nttp/enum/authy-ticket-type.enum";
import { CommonDialogComponent } from "@pg-app/common/common-dialog/common-dialog.component";
import { DialogTypeEnum } from "@nttp/enum/common-dialog-type.enum";
import { Router } from "@angular/router";
import { error } from "console";
import { Bank } from "@pg-app/shared/models/bank";


@Component({
    selector: 'np-add-new-approved-payer',
    templateUrl: './add-new-approved-payer.component.html',
    styleUrls: ['./add-new-approved-payer.component.scss']
  })
  export class AddNewApprovedPayerComponent implements OnInit {

    totalStep = [
      'Step one',
      'Step two',
      'Approval',
    ];
    currentStep = 1;

    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    bankDetailsFormGroup: FormGroup;
    approvedPayer: NewApprovedPayer = new NewApprovedPayer();
    countries: Country[] = [];
    currencies: Country[] = [];
    showEmail = false;
    isFasterPay: any;
    isFasterPayandGBP: boolean = false;
    isIBANRequired: boolean = false;
    isBankCodeAndAccountMandatory: boolean = false;
    isBankCode9Digits: boolean = false;
    bankConfig: any;
    validationOk: boolean = false;
    bankAccountTypes = BankAccountTypes;
    payerTypes = BeneficiaryTypes;
    authyCompleted: boolean;
    action: any;
    btnName = 'Continue';
    ticketType = AuthyTicketTypeEnum.CreateRecipient;
  
    @Output()
    submited = new EventEmitter<boolean>()
    showPsp: boolean;
    pinCodeError = null;
  sendOnetouchSuccess: boolean;

    constructor(private _formBuilder: FormBuilder,
                private dialog: MatDialog,
                private shareService: ShareService,
                private utilityService: UtilityService,
                private recipientService: RecipientService,
                private toastrService: ToastrService,
                public registerService: RegistrationStep2Service,
                public approvedPayerService: ApprovedPayerService,
                private router: Router) 
    {}

    ngOnInit(): void {
      this.firstFormGroup = this._formBuilder.group({
        payerType: [this.approvedPayer.payerType, Validators.required],
        address1: [this.approvedPayer.address1 || null, [Validators.maxLength(35), Validators.pattern(Regex.nonSwiftCharacters)]],
        address2: [this.approvedPayer.address2 || null, [Validators.maxLength(35), Validators.pattern(Regex.nonSwiftCharacters)]],
        phone: [this.approvedPayer.phone || null, [Validators.pattern(Regex.phoneCharacters)]],
        currency: [this.approvedPayer.currency || null, Validators.required],
        legalName: [this.approvedPayer.legalName || null, [Validators.required, Validators.pattern(Regex.firstNameLastName)]],
        emailNotification: [this.approvedPayer.emailNotification || false],
        email: [this.approvedPayer.email || null],
        isPsp: [this.approvedPayer.isPSP || false],
        pspName: [this.approvedPayer.paymentServiceProvider || null],
        country: [this.approvedPayer.country, Validators.required],
        city: [this.approvedPayer.city || null, [Validators.maxLength(60), Validators.pattern(Regex.nonSwiftCharacters)]],
        state: [this.approvedPayer.state || null, [Validators.maxLength(50), Validators.pattern(Regex.nonSwiftCharacters)]],
        postCode: [this.approvedPayer.postCode || null, [Validators.maxLength(12), Validators.pattern(Regex.nonSwiftCharacters)]],
        taxId: [this.approvedPayer.taxId || null, [Validators.pattern(Regex.nonSwiftCharacters)]]
      });

      this.secondFormGroup = this._formBuilder.group({
        sortCode: ['', [Validators.pattern(Regex.sixDigitPattern)]],
        accountNumber: [''],
        iban: [''],
        bankCode: [''],
        swiftCode: ['', [Validators.pattern(Regex.swiftCodePattern)]],
      });

      this.bankDetailsFormGroup = this._formBuilder.group({
        bankName: [''],
        address1: [''],
        address2: [''],
        address3: [''],
        city: [''],
        stateProvince: [''],
        zipPostalCode: [''],
        country: [],
        reference: ['', [Validators.maxLength(70), Validators.pattern(Regex.nonSwiftCharacters)]],
        mandate: [false],
        purposeOfPayment: [''],
        bankAccountType: ['']
      });
      this.getCountries();
      this.getCurrencies();
      this.getBankingConfig();

      this.secondFormGroup.valueChanges.pipe(debounceTime(450)).subscribe(() => {
        this.validationOk = false;
        this.resetBankDetailForm();
      });
    }

    resetBankDetailForm() {
      this.bankDetailsFormGroup.patchValue({
        bankName: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        stateProvince: '',
        zipPostalCode: '',
      });
    }

    get payerType() {
      return this.firstFormGroup.get('payerType');
    }
    get legalName() {
      return this.firstFormGroup.get('legalName');
    }
    get country() {
      return this.firstFormGroup.get('country');
    }
    get phone() {
      return this.firstFormGroup.get('phone');
    }
    get address1() {
      return this.firstFormGroup.get('address1');
    }
    get address2() {
      return this.firstFormGroup.get('address2');
    }
    get city() {
      return this.firstFormGroup.get('city');
    }
    get state() {
      return this.firstFormGroup.get('state');
    }
    get postCode() {
      return this.firstFormGroup.get('postCode');
    }
    get taxId() {
      return this.firstFormGroup.get('taxId');
    }
    get currency() {
      return this.firstFormGroup.get('currency');
    }
    get emailNotification() {
      return this.firstFormGroup.get('emailNotification');
    }
    get email() {
      return this.firstFormGroup.get('email');
    }
    get isPsp() {
      return this.firstFormGroup.get('isPsp');
    }
    get pspName() {
      return this.firstFormGroup.get('pspName');
    }
    get sortCode() {
      return this.secondFormGroup.get('sortCode');
    }
    get accountNumber() {
      return this.secondFormGroup.get('accountNumber');
    }
    get iban() {
      return this.secondFormGroup.get('iban');
    }
    get bankCode() {
      return this.secondFormGroup.get('bankCode');
    }
    get swiftCode() {
      return this.secondFormGroup.get('swiftCode');
    }
    get bankName() {
      return this.secondFormGroup.get('bankName');
    }
    get bankAddress1() {
      return this.bankDetailsFormGroup.get('address1');
    }
    get bankAddress2() {
      return this.bankDetailsFormGroup.get('address2');
    }
    get bankAddress3() {
      return this.bankDetailsFormGroup.get('address3');
    }
    get bankAccountType() {
      return this.bankDetailsFormGroup.get('bankAccountType');
    }
    get bankCountry() {
      return this.bankDetailsFormGroup.get('country');
    }
    get bankStateProvinceCity() {
      return this.bankDetailsFormGroup.get('stateProvince');
    }
    get bankZipPostalCode() {
      return this.bankDetailsFormGroup.get('zipPostalCode');
    }
    get bankCity() {
      return this.bankDetailsFormGroup.get('city');
    }
    get bankReference() {
      return this.bankDetailsFormGroup.get('reference');
    }
    get mandate() {
      return this.bankDetailsFormGroup.get('mandate');
    }
    get purposeOfPayment() {
      return this.bankDetailsFormGroup.get('purposeOfPayment');
    }

    validateAndAutoFillBankDetails() {
      this.secondFormGroup.markAllAsTouched();
      if (!this.secondFormGroup.valid) {
        return;
      }
  
      const country = this.country.value ? this.countries.find(p => p.name.toLowerCase() === this.country.value.toLowerCase()) : null;
      const currency = this.currency.value ? this.currencies.find(p => p.code.toLowerCase() === this.currency.value.toLowerCase()) : null;

      const iBan = this.iban.value;
      const bankCode = this.bankCode.value;
      const swiftCode = this.swiftCode.value;
      const accountNumber = this.accountNumber.value;
      const sortCode = this.sortCode.value;
  
      let param = {
        countryCode: country.code,
        currencyCode: currency.code,
        accountNumber: null,
        sortCode: null,
        bankCode: null,
        iban: null,
        swiftCode: null
      }
  
      if (this.isFasterPayandGBP) {
        if (iBan) {
          param.iban = iBan;
        } else {
          param.sortCode = sortCode;
          param.accountNumber = accountNumber;
        }
      } else if (this.isIBANRequired) {
        param.iban = iBan;
      } else if (!this.isBankCodeAndAccountMandatory) {
        param.accountNumber = accountNumber;
        if (bankCode) {
          param.bankCode = bankCode;
        } else {
          param.swiftCode = swiftCode;
        }
      } else {
        param.accountNumber = accountNumber;
        param.bankCode = bankCode;
      }
  
      this.validationOk = false;
  
      this.recipientService.validate(param).subscribe(
        data => {
          if (!data) {
            this.toastrService.error(`Unable to validate. Please check the details and try again`);
            return;
          }
  
          if (data.CountryCode !== country.code) {
            this.toastrService.error('Incorrect bank country. Please correct the bank country to ' + data.countryCode);
            return;
          }
          const countryBank = this.country.value ? this.countries.find(p => p.code.toLowerCase() === data.CountryCode.toLowerCase()) : null;
          this.bankDetailsFormGroup.patchValue({
            bankName: data.Bank_Name,
            address1: data.Address1,
            address2: data.Address2,
            address3: data.Address3,
            city: data.City,
            stateProvince: data.State_Province,
            zipPostalCode: data.Zip_Postal,
            reference: data.Reference,
            country: countryBank
          });
  
          this.validationOk = true;
        }
      );
    }

    cancel() {
      this.router.navigate(['/client/approved-payers']);
    }

    private getCountries() {
      this.shareService.countryList$.subscribe(
        data => {
          data.forEach(item => {
            const flagIcon = (item.code.length <= 2 ? item.code : item.code.substring(0, 2)).toLowerCase();
            item.flag = `flag-icon flag-icon-${flagIcon}`;
          });
          this.countries = data || [];
        }
      );
    }

    focusNo() {
      this.showEmail = false;
      this.email.setValidators([]);
      this.email.setValue('');
      this.emailNotification.setValue(false);
    }
  
    focusYes() {
      this.showEmail = true;
      this.emailNotification.setValue(true);
    }
    focusPspNo() {
      this.showPsp = false;
      this.pspName.setValidators([]);
      this.isPsp.setValue(false);
      this.pspName.setValue('');
    }
  
    focusPspYes() {
      this.showPsp = true;
      this.email.setValidators([Validators.required, Validators.maxLength(35)]);
      this.isPsp.setValue(true);
    }

    loadBankingType()
    {
      this.firstFormGroup.markAsTouched();
      this.currentStep = 2;
      if(!this.firstFormGroup.valid)
      {
        return;
      }
      const country = this.country.value ? this.countries.find(p => p.name.toLowerCase() === this.country.value.toLowerCase()) : null;
      const currency = this.currency.value ? this.currencies.find(p => p.code.toLowerCase() === this.currency.value.toLowerCase()) : null;
     let dto = {
          countryId: country.id,
          currencyId:currency.id
      };

      this.shareService.getBankingType(dto).subscribe(bankingType => {
        this.isFasterPay = country.isFasterPay;
        this.isFasterPayandGBP = bankingType === BankingTypes.Case1_FasterPay_GBP;
        this.isIBANRequired = bankingType === BankingTypes.Case2_IBAN;
        this.isBankCodeAndAccountMandatory = bankingType === BankingTypes.Case3_BankCode;
        this.isBankCode9Digits = !!this.bankConfig.require9DigitBankCode.find(p => p.countryCode === country.code && p.currencyCode === currency.code);
        
        const accountNumberPattern = this.isFasterPay ? Regex.eightDigitPattern : Regex.alphabetPattern;
        const bankCodePattern = this.isBankCode9Digits ? Regex.nineDigitPattern : Regex.alphabetPattern;

        // form validation
        const formValidator = this.isFasterPayandGBP ? fasterPayGbpBankDetailsValidator() :
          !this.isFasterPayandGBP && !this.isIBANRequired && !this.isBankCodeAndAccountMandatory ?
            [
              swiftCodeValidator(),
              swiftOrBankCodeValidator()
            ] : [];

        // iban validation
        const ibanValidator = this.isIBANRequired ?
          [
            Validators.pattern(Regex.alphabetAndSpacePattern),
            Validators.maxLength(34), Validators.minLength(15),
            Validators.required
          ]
          :
          [
            Validators.pattern(Regex.alphabetAndSpacePattern),
            Validators.maxLength(34), Validators.minLength(15)
          ];

        // account number validation
        const accountNumberValidator = !this.isFasterPayandGBP && !this.isIBANRequired ?
          [
            Validators.pattern(accountNumberPattern),
            Validators.required
          ] :
          [Validators.pattern(accountNumberPattern)];

        // bank code validation
        const bankCodeValidation = this.isBankCodeAndAccountMandatory ?
          [
            Validators.pattern(bankCodePattern),
            Validators.maxLength(50),
            Validators.required
          ] :
          [
            Validators.pattern(bankCodePattern),
            Validators.maxLength(50),
          ];

        this.secondFormGroup.get('accountNumber').setValidators(accountNumberValidator);
        this.secondFormGroup.get('accountNumber').updateValueAndValidity();
        this.secondFormGroup.get('iban').setValidators(ibanValidator);
        this.secondFormGroup.get('iban').updateValueAndValidity();
        this.secondFormGroup.get('bankCode').setValidators(bankCodeValidation);
        this.secondFormGroup.get('bankCode').updateValueAndValidity();
        this.secondFormGroup.setValidators(formValidator);
        this.secondFormGroup.updateValueAndValidity();
      });
    }

    onetouchApproved() {
      this.authyCompleted = true;
      this.addPayer();
    }

    private getBankingConfig() {
      this.recipientService.getBankingConfig().subscribe(res => {
        this.bankConfig = res;
      });
    }

    private getCurrencies() {
      this.utilityService.getCurrencies().subscribe(
        data => {
          data.forEach(item => {
            const flagIcon = (item.code.length <= 2 ? item.code : item.code.substring(0, 2)).toLowerCase();
            item.flag = `flag-icon flag-icon-${flagIcon}`;
          });
          this.currencies = data || [];
        },
      );
    }

    sendPassCode(event = null) {
      this.pinCodeError = null;
      const method = event ? event.method : VerifyTypeSendCodeEnum.Onetouch;
      this.recipientService.sendPassCode(method).subscribe(
        _result => {
          if (event && event.isTryAgain) {
            this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
          }
          if (!event) {
            this.sendOnetouchSuccess = true;
          }
        }
      );
    }

    changeStatus(event) {
      this.authyCompleted = event;
    }

    onSubmittedAuthy(event) {
      this.pinCodeError = null;
      this.recipientService.verificationPassCode(event.code, event.verificationType).subscribe(
        _result => {
          this.addPayer();
        },
        _error => {
          this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
        }
      );
    }

    bankDetailsFilled()
    {
      this.currentStep = 3;
    }

    exceedInvalidCode() {
      this.dialog.open(CommonDialogComponent, {
        data: {
          title:
            'You have reached the maximum number of attempts.<br>Please contact our support via email or phone number.',
          dialogType: DialogTypeEnum.Success,
          routingUrl: '/client/manage-recipient'
        },
        disableClose: true
      });
    }
  
    private addPayer()
    {
      const currency = this.currencies.find(p => p.code.toLowerCase() === this.currency.value.toLowerCase());
      const country = this.countries.find(p => p.name.toLowerCase() === this.country.value.toLowerCase());
      const countryBank = this.countries.find(p => p.code.toLowerCase() === this.bankCountry.value.code.toLowerCase());

      let approvedPayer: NewApprovedPayer = new NewApprovedPayer();
      approvedPayer.legalName = this.legalName.value;
      approvedPayer.address1 = this.address1.value;
      approvedPayer.address2 = this.address2.value;
      approvedPayer.currency = currency;
      approvedPayer.currencyId = currency.id;
      approvedPayer.country = country;
      approvedPayer.countryId = country.id;
      approvedPayer.city = this.city.value;
      approvedPayer.email = this.email.value;
      approvedPayer.emailNotification = this.emailNotification.value;
      approvedPayer.isPSP = this.isPsp.value;
      approvedPayer.paymentServiceProvider = this.isPsp.value ? new PaymentServiceProvider(this.pspName.value) : null;
      approvedPayer.payerType = this.payerType.value;
      approvedPayer.phone = this.phone.value;
      approvedPayer.postCode = this.postCode.value;
      approvedPayer.state = this.state.value;
      approvedPayer.taxId = this.taxId.value;
      approvedPayer.payerBank = new Bank();
      approvedPayer.payerBank.accountNumber = this.accountNumber.value;
      approvedPayer.payerBank.address1 = this.bankAddress1.value;
      approvedPayer.payerBank.address2 = this.bankAddress2.value;
      approvedPayer.payerBank.address3 = this.bankAddress3.value;
      approvedPayer.payerBank.bankAccountType = this.bankAccountType.value;
      approvedPayer.payerBank.bankCode = this.bankCode.value;
      approvedPayer.payerBank.country = countryBank;
      approvedPayer.payerBank.countryId = countryBank.id;
      approvedPayer.payerBank.city = this.city.value;
      approvedPayer.payerBank.iBan = this.iban.value;
      approvedPayer.payerBank.swiftCode = this.swiftCode.value;
      approvedPayer.payerBank.postCode = this.bankZipPostalCode.value;
      approvedPayer.payerBank.sortCode = this.sortCode.value;
      approvedPayer.payerBank.reference = this.bankReference.value;
      approvedPayer.payerBank.sortCodeUK = this.sortCode.value;

      this.approvedPayerService.saveNewPayer(approvedPayer).subscribe(result => 
        {
          this.dialog.open(CommonDialogComponent, {
            data: {
              title: 'New approved payer has been registered successfully.',
              dialogType: DialogTypeEnum.Success,
              routingUrl: '/client/approved-payers'
            },
            disableClose: true
          });
        
        });
    }
}